// US phone helpers — live input formatting, completeness check, display formatting.
// Shared by the horse-page OwnersCard and the standalone Owners directory.

// Strip to digits and build (xxx) xxx-xxxx progressively as the user types.
export function formatPhoneInput(value) {
  const d = (value || '').replace(/\D/g, '').slice(0, 10);
  if (d.length === 0) return '';
  if (d.length < 4) return `(${d}`;
  if (d.length < 7) return `(${d.slice(0, 3)}) ${d.slice(3)}`;
  return `(${d.slice(0, 3)}) ${d.slice(3, 6)}-${d.slice(6)}`;
}

// Empty is allowed (phone is optional). Otherwise require a full US number.
export function isCompletePhone(value) {
  const d = (value || '').replace(/\D/g, '');
  return d.length === 0 || d.length === 10 || (d.length === 11 && d[0] === '1');
}

// Format a stored value for display; fall back to the raw string if it isn't
// a clean 10-digit (or 1+10) number (e.g. legacy/seed data like "555-0106").
export function displayPhone(value) {
  if (!value) return '';
  const d = value.replace(/\D/g, '');
  if (d.length === 10) return `(${d.slice(0, 3)}) ${d.slice(3, 6)}-${d.slice(6)}`;
  if (d.length === 11 && d[0] === '1') return `(${d.slice(1, 4)}) ${d.slice(4, 7)}-${d.slice(7)}`;
  return value;
}

/**
 * A `tel:` href, so tapping a number on a phone offers to dial it.
 * Returns null when there's nothing dialable, which is the signal to render
 * plain text instead of a dead link.
 *
 * US numbers go out as +1E.164 — the unambiguous form, and what a handset
 * wants. Anything else keeps its digits (plus a leading + if it had one) so a
 * short code or an imported oddity still dials rather than being dropped.
 */
export function telHref(value) {
  if (!value) return null;
  const d = value.replace(/\D/g, '');
  if (!d) return null;
  if (d.length === 10) return `tel:+1${d}`;
  if (d.length === 11 && d[0] === '1') return `tel:+${d}`;
  return `tel:${value.trim().startsWith('+') ? '+' : ''}${d}`;
}
